import React from 'react';
interface BrandTiktokProps {
  size?: number;
  className?: string;
}
export const BrandTiktok = ({
  size = 24,
  className = ''
}: BrandTiktokProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-324" data-mp="1cry4n9v5i9gz">
      <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" data-id="element-325" data-mp="20jdcfi5p5izm" />
    </svg>;
};